import { ColorPalette } from 'theme/colors';

export const customTheme = {
  searchInput: {
    text: {
      boxShadow: 'none',
      height: '56px',
      padding: '0 10px',
      border: `2px solid rgba(${ColorPalette.RGB.PhilippineSilver}, 0.25)`,
      label: {
        fontSize: '16px',
        color: ColorPalette.HEX.PineTree,
      },
      detail: {
        fontSize: '11px',
        color: ColorPalette.HEX.PineTree,
      },
      placeholder: {
        label: {
          color: ColorPalette.HEX.DimGray2,
        },
        detail: {
          color: ColorPalette.HEX.PhilippineSilver,
        },
      },
    },
    date: {
      background: ColorPalette.HEX.White,
      boxShadow: 'none',
      height: '56px',
      padding: '0 10px',
      border: `2px solid rgba(${ColorPalette.RGB.PhilippineSilver}, 0.25)`,
      label: {
        fontSize: '14px',
        color: ColorPalette.HEX.PineTree,
        marginTop: '20px',
      },
      detail: {
        fontSize: '11px',
        color: ColorPalette.HEX.DimGray2,
        top: '6px',
      },
      placeholder: {
        label: {
          color: ColorPalette.HEX.PhilippineSilver,
        },
      },
      disabled: {
        background: ColorPalette.HEX.Cultured2,
        border: `px solid rgba(${ColorPalette.RGB.PhilippineSilver}, 0.25)`,
        boxShadow: 'none',
        label: {
          color: ColorPalette.HEX.PhilippineSilver,
          marginTop: '22px',
        },
        detail: {
          color: ColorPalette.HEX.PineTree,
        },
      },
    },
    time: {
      background: ColorPalette.HEX.White,
      boxShadow: 'none',
      height: '42px',
      padding: '0 10px',
      border: `2px solid rgba(${ColorPalette.RGB.PhilippineSilver}, 0.25)`,
      label: {
        fontSize: '14px',
        color: ColorPalette.HEX.PineTree,
        marginTop: '0',
      },
      detail: {
        fontSize: '11px',
        color: ColorPalette.HEX.DimGray2,
        top: '8px',
      },
      placeholder: {
        label: {
          color: ColorPalette.HEX.PhilippineSilver,
        },
      },
      disabled: {
        background: ColorPalette.HEX.Cultured2,
        border: `1px solid rgba(${ColorPalette.RGB.PhilippineSilver}, 0.25)`,
        boxShadow: 'none',
        label: {
          color: ColorPalette.HEX.PhilippineSilver,
          marginTop: '0',
        },
        detail: {
          color: ColorPalette.HEX.PineTree,
        },
      },
    },
    travelArranger: {
      background: ColorPalette.HEX.White,
      boxShadow: 'none',
      height: '42px',
      padding: '0 10px',
      border: `2px solid rgba(${ColorPalette.RGB.PhilippineSilver}, 0.25)`,
      label: {
        fontSize: '14px',
        color: ColorPalette.HEX.PineTree,
        marginTop: '0',
      },
      detail: {
        fontSize: '11px',
        color: ColorPalette.HEX.DimGray2,
        top: '8px',
        display: 'none',
      },
      guest: {
        fontSize: '14px',
        color: ColorPalette.HEX.Manatee,
      },
      placeholder: {
        label: {
          color: ColorPalette.HEX.PhilippineSilver,
        },
      },
    },
  },
};
